let NodeHtmlMarkdown = null;
const loadDependencies = async () => {
  if (!NodeHtmlMarkdown) {
    const nhm = await import('node-html-markdown');
    NodeHtmlMarkdown = nhm.NodeHtmlMarkdown;
  }
};
export const getPageUrl = () => {
  var _document;
  return ((_document = document) == null || (_document = _document.location) == null ? void 0 : _document.href) || '';
};
export const getPageContent = async () => {
  console.log('[getPageContent] Starting page content extraction');
  const errors = [];
  let pageUrl = '';
  let pageHtml = '';
  let pageContent = '';
  try {
    await loadDependencies();
    // Get page URL
    try {
      var _document2;
      pageUrl = ((_document2 = document) == null || (_document2 = _document2.location) == null ? void 0 : _document2.href) || '';
      if (!pageUrl) {
        console.warn('[getPageContent] Could not retrieve page URL');
        errors.push('Could not retrieve page URL');
      } else {
        console.log('[getPageContent] Successfully retrieved URL:', pageUrl);
      }
    } catch (error) {
      console.error('[getPageContent] Error getting page URL:', error);
      errors.push(`Error getting page URL: ${error.message}`);
    }

    // Get page HTML with fallbacks
    console.log('[getPageContent] Attempting to extract HTML content');
    try {
      // Try main content first
      try {
        var _document3;
        pageHtml = ((_document3 = document) == null || (_document3 = _document3.documentElement) == null || (_document3 = _document3.querySelector('main')) == null ? void 0 : _document3.outerHTML) || '';
        if (pageHtml) {
          console.log('[getPageContent] Successfully extracted main content');
        }
      } catch (error) {
        console.warn('[getPageContent] Error getting main content:', error);
        errors.push(`Error getting main content: ${error.message}`);
      }

      // Fallback to body if main not found
      if (!pageHtml) {
        console.log('[getPageContent] Falling back to body content');
        try {
          var _document4;
          pageHtml = ((_document4 = document) == null || (_document4 = _document4.body) == null ? void 0 : _document4.outerHTML) || '';
          if (pageHtml) {
            console.log('[getPageContent] Successfully extracted body content');
          }
        } catch (error) {
          console.warn('[getPageContent] Error getting body content:', error);
          errors.push(`Error getting body content: ${error.message}`);
        }
      }

      // Final fallback to entire document
      if (!pageHtml) {
        console.log('[getPageContent] Falling back to entire document');
        try {
          var _document5;
          pageHtml = ((_document5 = document) == null || (_document5 = _document5.documentElement) == null ? void 0 : _document5.outerHTML) || '';
          if (pageHtml) {
            console.log('[getPageContent] Successfully extracted document content');
          }
        } catch (error) {
          console.error('[getPageContent] Error getting document content:', error);
          errors.push(`Error getting document content: ${error.message}`);
        }
      }
      if (!pageHtml) {
        console.warn('[getPageContent] No HTML content could be retrieved');
        pageHtml = '<html>Page HTML not found</html>';
        errors.push('No HTML content could be retrieved');
      }
    } catch (error) {
      console.error('[getPageContent] Fatal error getting HTML:', error);
      errors.push(`Fatal error getting HTML: ${error.message}`);
      pageHtml = '<html>Page HTML not found</html>';
    }

    // Process HTML content
    console.log('[getPageContent] Processing HTML content');
    try {
      const cleanedHtml = removePii(pageHtml);
      pageContent = new NodeHtmlMarkdown().translate(cleanedHtml).trim();
      console.log('[getPageContent] Successfully processed HTML content');
    } catch (error) {
      console.error('[getPageContent] Error processing HTML content:', error);
      errors.push(`Error processing HTML content: ${error.message}`);
      // Attempt basic cleanup if processing fails
      try {
        pageContent = pageHtml.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        console.log('[getPageContent] Successfully performed fallback processing');
      } catch (fallbackError) {
        console.error('[getPageContent] Error in fallback content processing:', fallbackError);
        errors.push(`Error in fallback content processing: ${fallbackError.message}`);
        pageContent = 'Error processing page content';
      }
    }
    if (errors.length > 0) {
      console.warn('[getPageContent] Completed with warnings:', errors);
    } else {
      console.log('[getPageContent] Successfully completed content extraction');
    }
    return {
      pageUrl,
      pageHtml: pageContent.substring(0, 8000),
      // hard limit of 10000 characters
      errors
    };
  } catch (error) {
    console.error('[getPageContent] Fatal error:', error);
    return {
      pageUrl,
      pageHtml,
      errors: [...errors, `Fatal error: ${error.message}`]
    };
  }
};
export const scrapeUrl = async url => {
  const errors = [];
  const data = {
    title: '',
    metaDescription: '',
    metaKeywords: '',
    headings: {
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: []
    },
    paragraphs: [],
    links: [],
    mainContent: ''
  };
  try {
    // Fetch attempt
    let htmlText;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        errors.push(`HTTP Error: ${response.status}`);
        return {
          success: false,
          content: JSON.stringify({
            errors,
            partialResult: null
          })
        };
      }
      htmlText = await response.text();
    } catch (error) {
      errors.push(`Fetch error: ${error.message}`);
      return {
        success: false,
        content: JSON.stringify({
          errors,
          partialResult: null
        })
      };
    }

    // Parse HTML
    let doc;
    try {
      const parser = new DOMParser();
      doc = parser.parseFromString(htmlText, 'text/html');
    } catch (error) {
      errors.push(`HTML parsing error: ${error.message}`);
      return {
        success: false,
        content: JSON.stringify({
          errors,
          partialResult: {
            rawText: htmlText
          }
        })
      };
    }

    // Remove unwanted elements
    try {
      const unwantedSelectors = 'script, style, iframe, img, svg, video, audio, noscript';
      doc.querySelectorAll(unwantedSelectors).forEach(el => el.remove());
    } catch (error) {
      errors.push(`Error removing unwanted elements: ${error.message}`);
    }

    // Remove dangerous attributes
    try {
      doc.querySelectorAll('*').forEach(el => {
        try {
          ['onclick', 'onload', 'onunload', 'onchange', 'onsubmit', 'onmouseover', 'onmouseout', 'style'].forEach(attr => {
            el.removeAttribute(attr);
          });
        } catch (attrError) {
          errors.push(`Error removing attributes from element: ${attrError.message}`);
        }
      });
    } catch (error) {
      errors.push(`Error in attribute cleanup: ${error.message}`);
    }

    // Extract metadata with individual try-catch blocks
    try {
      var _doc$querySelector;
      data.title = ((_doc$querySelector = doc.querySelector('title')) == null || (_doc$querySelector = _doc$querySelector.textContent) == null ? void 0 : _doc$querySelector.trim()) || '';
    } catch (error) {
      errors.push(`Error extracting title: ${error.message}`);
    }
    try {
      var _doc$querySelector2;
      data.metaDescription = ((_doc$querySelector2 = doc.querySelector('meta[name="description"]')) == null ? void 0 : _doc$querySelector2.getAttribute('content')) || '';
    } catch (error) {
      errors.push(`Error extracting meta description: ${error.message}`);
    }

    // Extract headings
    ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'].forEach(level => {
      try {
        data.headings[level] = Array.from(doc.querySelectorAll(level)).map(el => {
          var _el$textContent;
          return ((_el$textContent = el.textContent) == null ? void 0 : _el$textContent.trim()) || '';
        }).filter(text => text.length > 0);
      } catch (error) {
        errors.push(`Error extracting ${level} headings: ${error.message}`);
        data.headings[level] = [];
      }
    });

    // Extract paragraphs
    try {
      data.paragraphs = Array.from(doc.querySelectorAll('p')).map(el => {
        try {
          return cleanText(el.textContent || '');
        } catch (error) {
          errors.push(`Error cleaning paragraph text: ${error.message}`);
          return el.textContent || '';
        }
      }).filter(text => text.length > 0);
    } catch (error) {
      errors.push(`Error extracting paragraphs: ${error.message}`);
    }

    // Extract links
    try {
      data.links = Array.from(doc.querySelectorAll('a')).map(el => {
        try {
          return {
            text: cleanText(el.textContent || ''),
            href: el.getAttribute('href') || ''
          };
        } catch (error) {
          errors.push(`Error processing link: ${error.message}`);
          return {
            text: el.textContent || '',
            href: el.getAttribute('href') || ''
          };
        }
      }).filter(link => link.href || link.text);
    } catch (error) {
      errors.push(`Error extracting links: ${error.message}`);
    }

    // Extract main content as fallback
    try {
      data.mainContent = cleanText(doc.body.textContent || '');
    } catch (error) {
      errors.push(`Error extracting main content: ${error.message}`);
      try {
        data.mainContent = doc.body.textContent || '';
      } catch (fallbackError) {
        errors.push(`Error extracting raw main content: ${fallbackError.message}`);
      }
    }
    return {
      success: errors.length === 0,
      content: JSON.stringify({
        errors: errors.length > 0 ? errors : undefined,
        data
      })
    };
  } catch (error) {
    errors.push(`Fatal error: ${error.message}`);
    return {
      success: false,
      content: JSON.stringify({
        errors,
        partialResult: data
      })
    };
  }
};

// Cleans text content.
function cleanText(text) {
  try {
    return text.replace(/(\r\n|\n|\r|\t)/gm, ' ').replace(/\s+/g, ' ').replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>').replace(/&quot;/gi, '"').trim();
  } catch (error) {
    console.error('[cleanText] Failed to clean text:', error);
    return text || '';
  }
}
function removePii(htmlString) {
  console.log('[removePii] Starting PII removal process');
  try {
    const EXCLUDE_DATA_ATTR = 'data-pii';
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    try {
      const elements = doc.querySelectorAll(`[${EXCLUDE_DATA_ATTR}]`);
      console.log(`[removePii] Found ${elements.length} PII elements to remove`);
      elements.forEach(element => {
        try {
          var _element$parentNode;
          (_element$parentNode = element.parentNode) == null || _element$parentNode.removeChild(element);
        } catch (e) {
          console.warn('[removePii] Failed to remove PII element:', e);
        }
      });
      return doc.documentElement.outerHTML;
    } catch (e) {
      console.error('[removePii] Error processing PII elements:', e);
      return htmlString;
    }
  } catch (e) {
    console.error('[removePii] Fatal error, returning original string:', e);
    return htmlString;
  }
}
export function reduceHtmlToMarkdown(html) {
  const errors = [];
  let reduced = html;
  const safeReplace = (text, regex, replacement) => {
    try {
      return text.replace(regex, replacement);
    } catch (e) {
      errors.push(`Transformation failed: ${e.message}`);
      return text;
    }
  };
  try {
    // Basic cleanup with fallback
    console.log('[reduceHtmlToMarkdown] Performing basic cleanup');
    try {
      reduced = safeReplace(reduced, /<!--[\s\S]*?-->/g, '');
      reduced = safeReplace(reduced, /<(script|style)[\s\S]*?<\/\1>/gi, '');
      reduced = safeReplace(reduced, /<head[\s\S]*?<\/head>/gi, '');
      reduced = safeReplace(reduced, /<(meta|link)[^>]*>/gi, '');
    } catch (e) {
      errors.push(`Basic cleanup failed: ${e.message}`);
      // Continue with original content
    }

    // Form fields transformation with fallback
    try {
      reduced = safeReplace(reduced, /<input([^>]+?)\/?>/gi, (_match, attrs) => {
        try {
          const name = (attrs.match(/name=["']?([^"'\s>]+)/i) || [])[1] || '';
          const value = (attrs.match(/value=["']?([^"'\s>]+)/i) || [])[1] || '';
          const placeholder = (attrs.match(/placeholder=["']?([^"']+)/i) || [])[1] || '';
          return `[Input${name ? ' name: ' + name : ''}${value ? ', value: ' + value : ''}${placeholder ? ', placeholder: ' + placeholder : ''}]`;
        } catch (e) {
          errors.push(`Input transformation failed: ${e.message}`);
          return '[Input]';
        }
      });
    } catch (e) {
      errors.push(`Form fields transformation failed: ${e.message}`);
    }

    // Links transformation with fallback
    try {
      reduced = safeReplace(reduced, /<a[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/gi, (_match, url, text) => {
        try {
          return `[${text.trim() || 'link'}](${url})`;
        } catch (e) {
          errors.push(`Link transformation failed: ${e.message}`);
          return text || url || '[link]';
        }
      });
    } catch (e) {
      errors.push(`Links transformation failed: ${e.message}`);
    }

    // Headers transformation with fallback
    try {
      reduced = safeReplace(reduced, /<(h[1-6])[^>]*>(.*?)<\/\1>/gi, (_match, tag, content) => {
        try {
          const level = parseInt(tag.slice(1), 10);
          return `\n${'#'.repeat(level)} ${content.trim()}\n`;
        } catch (e) {
          errors.push(`Header transformation failed: ${e.message}`);
          return `\n${content.trim()}\n`;
        }
      });
    } catch (e) {
      errors.push(`Headers transformation failed: ${e.message}`);
    }

    // Final cleanup with fallback
    try {
      reduced = reduced.replace(/<\/?[^>]+>/g, ' ');
      reduced = reduced.replace(/\n\s*\n/g, '\n\n').trim();
    } catch (e) {
      errors.push(`Final cleanup failed: ${e.message}`);
      try {
        // Extreme fallback: just remove all HTML tags
        reduced = reduced.replace(/<[^>]*>/g, ' ').trim();
      } catch (fallbackError) {
        errors.push(`Extreme fallback cleanup failed: ${fallbackError.message}`);
      }
    }

    // Ensure we always return something meaningful
    if (!reduced || reduced.trim().length === 0) {
      errors.push('Content was empty after processing');
      reduced = html;
    }
    if (errors.length > 0) {
      console.warn('[reduceHtmlToMarkdown] Completed with errors:', errors, reduced);
    } else {
      console.log('[reduceHtmlToMarkdown] Successfully completed conversion', reduced);
    }
    return JSON.stringify({
      errors: errors.length > 0 ? errors : undefined,
      content: reduced
    });
  } catch (e) {
    console.error('[reduceHtmlToMarkdown] Fatal error:', e);
    return JSON.stringify({
      errors: [...errors, `Fatal error: ${e.message}`],
      content: html || 'Failed to process content'
    });
  }
}
//# sourceMappingURL=getPageContent.js.map